import React, { Component } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  Collapse,
  Alert,
  IconButton,
  Typography,
  Grid,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ReadMoreIcon from '@mui/icons-material/ReadMore';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import moment from 'moment';
import axios from 'axios';
import axiosInstance from "./axiosConfig";
import JoditEditor from 'jodit-react';
import Serverurl from './Apiurl';
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";


export default class NotificationCalendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      nt_title: '',
      nt_descp: '',
      nt_date: null,
      nt_remainderdate: null,
      showMoreOptions: false,
      errorOpen: false,
      errorMessage: '',
      notification: null,
    };
  }

static getDerivedStateFromProps(nextProps, prevState) {
  if (
    nextProps.open !== prevState.open ||
    (nextProps.notification &&
      nextProps.notification.nt_id !==
        (prevState.notification ? prevState.notification.nt_id : null))
  ) {
    if (nextProps.notification) {
      const defaultReminderDate = nextProps.notification.nt_remainderdate
        ? new Date(nextProps.notification.nt_remainderdate)
        : nextProps.notification.nt_date
        ? new Date(
            new Date(nextProps.notification.nt_date).getTime() -
              24 * 60 * 60 * 1000
          )
        : nextProps.date
        ? new Date(new Date(nextProps.date).getTime() - 24 * 60 * 60 * 1000)
        : null;

      return {
        open: nextProps.open,
        nt_title: nextProps.notification.nt_title || "",
        nt_descp: nextProps.notification.nt_descp || "",
        nt_date: nextProps.notification.nt_date
          ? new Date(nextProps.notification.nt_date)
          : null,
        nt_remainderdate: defaultReminderDate,
        errorOpen: false,
        errorMessage: "",
        showMoreOptions: false,   
        notification: nextProps.notification,
      };
    }

    // If creating a new notification
    const defaultDate = nextProps.date ? new Date(nextProps.date) : new Date();
    const defaultReminder = new Date(
      defaultDate.getTime() - 24 * 60 * 60 * 1000
    );

    return {
      open: nextProps.open,
      nt_title: "",
      nt_descp: "",
      nt_date: defaultDate,
      nt_remainderdate: defaultReminder,
      errorOpen: false,
      errorMessage: "",
      showMoreOptions: false,    
      notification: null,
    };
  }
  return null;
}

  closeDialog = () => {
    this.setState({ errorOpen: false, errorMessage: '' });
    if (this.props.onClose) this.props.onClose();
  };

  handleChange = (field) => (event) => {
    this.setState({ [field]: event.target.value });
  };

handleDateChange = (field) => (date) => {
  if (field === 'nt_date') {
    this.setState((prev) => ({
      nt_date: date,
      nt_remainderdate: prev.nt_remainderdate && prev.nt_remainderdate < date
        ? prev.nt_remainderdate
        : new Date(date.getTime() - 24 * 60 * 60 * 1000) // default 1 day before
    }));
  } else {
    this.setState({ [field]: date });
  }
};

  validateAndSubmit = () => {
    const { nt_title, nt_descp, nt_date, nt_remainderdate, notification } = this.state;
    if (!nt_title.trim()) {
      this.setState({ errorOpen: true, errorMessage: 'Please enter a title' });
      return;
    }
    if (!nt_date) {
      this.setState({ errorOpen: true, errorMessage: 'Please select a date' });
      return;
    }

    const nt_date_iso = moment(nt_date).toISOString();
    const nt_remainderdate_iso = nt_remainderdate ? moment(nt_remainderdate).toISOString() : null;

    if (notification && notification.nt_id) {
      // edit
      axiosInstance.put(Serverurl + "notifications/update/" + notification.nt_id, {
        nt_title: nt_title.trim(),
        nt_descp: nt_descp.trim(),
        nt_date: nt_date_iso,
        nt_remainderdate: nt_remainderdate_iso,
		nt_modifieduserid: localStorage.getItem('DCuserid'),
      }).then(() => {
        this.closeDialog();
        if (this.props.onNotificationAdded) this.props.onNotificationAdded();
      }).catch(() => {
        this.setState({ errorOpen: true, errorMessage: 'Error updating notification' });
      });
    } else {
      // add
      axiosInstance.post(Serverurl + "notifications/insert", {
        nt_title: nt_title.trim(),
        nt_descp: nt_descp.trim(),
        nt_date: nt_date_iso,
        nt_remainderdate: nt_remainderdate_iso,
        nt_createduserid: localStorage.getItem('DCuserid'),
      }).then(() => {
        this.closeDialog();
        if (this.props.onNotificationAdded) this.props.onNotificationAdded();
      }).catch(() => {
        this.setState({ errorOpen: true, errorMessage: 'Error saving notification' });
      });
    }
  };

  toggleMoreOptions = () => {
    this.setState((prevState) => ({ showMoreOptions: !prevState.showMoreOptions }));
  };

handleDelete = () => {
  if (!this.state.notification || !this.state.notification.nt_id) return;

  confirmAlert({
    title: "Confirm Delete",
    message: "Are you sure you want to delete this notification?",
    buttons: [
      {
        label: "Yes",
        onClick: () => {
          axiosInstance.delete(
            Serverurl + "notifications/delete/" + this.state.notification.nt_id,
            { data: { nt_deleteduserid: localStorage.getItem("DCuserid") } }
          )
          .then(() => {
            this.closeDialog();
            if (this.props.onNotificationAdded) this.props.onNotificationAdded();
          })
          .catch(() => {
            this.setState({
              errorOpen: true,
              errorMessage: "Error deleting notification",
            });
          });
        },
      },
      {
        label: "No",
      },
    ],
  });
};

  render() {
    return (
      <Dialog open={this.state.open} onClose={this.closeDialog} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ position: 'relative', pr: 4 }}>
          {this.state.notification ? 'Notification' : 'Notification'}
          <IconButton
            aria-label="close"
            onClick={this.closeDialog}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Collapse in={this.state.errorOpen}>
            <Alert
              severity="error"
              action={
                <IconButton size="small" onClick={() => this.setState({ errorOpen: false })}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              }
            >
              {this.state.errorMessage}
            </Alert>
          </Collapse>

          <Typography variant="subtitle1" sx={{ mt: 1, mb: 0.5 }}>Date</Typography>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              disablePast
              format="dd/MM/yyyy"
              value={this.state.nt_date}
              onChange={this.handleDateChange('nt_date')}
             
            />
          </LocalizationProvider>

          <Typography variant="subtitle1" sx={{ mt: 2, mb: 0.5 }}>Title</Typography>
          <TextField
            fullWidth
            variant="outlined"
            margin="normal"
            value={this.state.nt_title}
            onChange={this.handleChange('nt_title')}
            placeholder="Enter title"
          />

          <Button
            variant="contained"
			size="small"
            className="frmPrimarybtn"
            onClick={this.toggleMoreOptions}
            startIcon={<ReadMoreIcon />}
            style={{ marginTop: '10px', textTransform: 'none' }}
          >
            MORE OPTIONS
          </Button>

          {this.state.showMoreOptions && (
            <>
              <Typography variant="subtitle1" sx={{ mt: 2, mb: 0.5 }}>Description</Typography>
              <JoditEditor
  value={this.state.nt_descp}
  onChange={(newContent) => this.setState({ nt_descp: newContent })}
/>

              <Typography variant="subtitle1" sx={{ mt: 2, mb: 0.5 }}>Reminder Date</Typography>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
  format="dd/MM/yyyy"
  value={this.state.nt_remainderdate}
  onChange={this.handleDateChange('nt_remainderdate')}
  maxDate={this.state.nt_date} 
  disablePast
/>
              </LocalizationProvider>
            </>
          )}
        </DialogContent>

<DialogActions>
  <Grid container alignItems="center" justifyContent="flex-end" spacing={2} sx={{ width: "100%", px: 2 }}>
    {this.state.notification && this.state.notification.nt_id && (
      <Grid item>
        <Button
		size="small"
          className="frmSecondarybtn"
          onClick={this.handleDelete}
          endIcon={<DeleteIcon />}
        >
          Delete
        </Button>
      </Grid>
    )}
    <Grid item>
      <Button
	  size="small"
        onClick={this.validateAndSubmit}
        color="primary"
        className="frmPrimarybtn"
        variant="contained"
        endIcon={<EditIcon />}
      >
        {this.state.notification ? 'Update' : 'Save'}
      </Button>
    </Grid>
  </Grid>
</DialogActions>
      </Dialog>
    );
  }
}
